import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wd-pannel-list',
  templateUrl: './pannel-list.component.html',
  styleUrls: ['./pannel-list.component.scss']
})
export class PannelListComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
